// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FtGP","title":"styles_title__1StmY"};